/**
 * MentionText — renders a plain string with `@handle` tokens highlighted as
 * inline purple pills. Safe: only splits, never dangerously sets HTML.
 */
export function MentionText({ text, className = "" }) {
  if (!text) return null;
  const parts = String(text).split(/(@[a-zA-Z0-9_\-\.]+)/g);
  return (
    <span className={className} data-testid="mention-text">
      {parts.map((p, i) =>
        p.startsWith("@") ? (
          <span
            key={i}
            className="bg-ccc-purple/10 text-ccc-purple-dark px-1 rounded font-medium"
            data-testid={`mention-pill-${p.slice(1)}`}
          >
            {p}
          </span>
        ) : (
          <span key={i}>{p}</span>
        )
      )}
    </span>
  );
}
